import Container from "react-bootstrap/Container"
import "../styles/Rules.css"
import { useTranslation } from "react-i18next"

const Rules = () => {

  const { t } = useTranslation()

  return (
    <Container>
      <h2 className="BREIKKI-rules-title">{t("rules_title")}</h2>
      <p>
        {t("rules_info_text") + " "}
        <a target="_blank" href="https://drive.google.com/file/d/1gdW2VdJwNd206Z39llNeJ23j1CcKMPDD/view">{t("rules_info_link_text")}</a>
        .
      </p>
      {/* <Container className="BREIKKI-pre BREIKKI-rules-container" dangerouslySetInnerHTML={{
        __html: `
        1. Yhdistyksen nimi ja kotipaikka
        Yhdistyksen nimi on Akateeminen biljardikerho BREIKKI ry ja sen kotipaikka on Tampere.

        2. Tarkoitus ja toimintamuodot
        Yhdistyksen tarkoituksena on tukea ja innostaa biljardiharrastusta Tampereen
        korkeakouluyhteisössä, sekä muodostaa yhteisö lajista kiinnostuneista opiskelijoista. Yhdistys
        mahdollistaa jäsenilleen biljardin harrastamisen edullisesti ja hyvässä seurassa. Yhdistys
        tarjoaa samalla mahdollisuuksia pelistä oppimiseen, uusien tuttavuuksien tekemiseen, ja
        oman osaamisensa jakamiseen yhteisön sisällä. Näiden tavoitteidensa kautta yhdistys edistää
        opiskelija- ja biljardikulttuuria Tampereella.
        Yhdistys pyrkii tavoitteisiinsa järjestämällä erinäisiä tapahtumia, kuten peli-iltoja,
        kisakatsomoita ja turnauksia. Toimintaansa yhdistys voi tukea ottamalla vastaan avustuksia
        ja lahjoituksia, hankkimalla omistukseensa tai hallintaansa toimintansa kannalta tarpeellista
        kiinteää ja irtainta omaisuutta, harjoittamalla myynti- ja välitystoimintaa, sekä järjestää
        huvitilaisuuksia ja arpajaisia asianomaisilla luvilla ja muilla samantapaisilla tavoilla.

        3. Jäsenet
        Yhdistyksellä on 3 jäsenluokkaa: varsinaiset jäsenet, kannatusjäsenet ja kunniajäsenet.
        3.1. Varsinaiset jäsenet
        Yhdistykseen jäseneksi voi liittyä jokainen Tampereen korkeakouluyhteisön opiskelija, joka
        hyväksyy yhdistyksen tarkoituksen ja säännöt sekä suorittaa yhdistyksen jäsenmaksun.
        Jäsenet hyväksyy hakemuksesta yhdistyksen hallitus.
        3.2. Kannatusjäsenet
        Kannatusjäseneksi voidaan hyväksyä yksityinen henkilö, joka haluaa tukea yhdistyksen
        toimintaa ja joka maksaa kannatusjäsenmaksun. Kannatusjäsenet hyväksyy hakemuksesta
        yhdistyksen hallitus. Kannatusjäsenellä on yhdistyksen kokouksissa läsnäolo- ja puheoikeus,
        mutta ei äänivaltaa.
        3.3. Kunniajäsenet
        Kunniajäseneksi voidaan hallituksen esityksestä yhdistyksen kokouksessa kutsua henkilö,
        joka on huomattavasti edistänyt ja tukenut yhdistyksen toimintaa. Kunniajäsenellä on
        yhdistyksen kokouksissa läsnäolo- ja puheoikeus, mutta ei äänivaltaa, paitsi jos hän on myös
        varsinainen jäsen, jolloin hänellä on kaikki varsinaisen jäsenen oikeudet.

        4. Jäsenmaksu ja kannatusjäsenmaksu
        Varsinaisilta jäseniltä perittävän vuotuisen jäsenmaksun suuruudesta päättää vuosikokous.
        Vuosittaisen jäsenmaksun tulee olla maksettuna 1. lokakuuta tai jäsen katsotaan eronneeksi.
        Jäsenmaksu on voimassa 1. kesäkuuta ja 31. toukokuuta välisen ajan.
        Kannatusjäseniltä perittävän vuotuisen kannatusjäsenmaksun suuruudesta päättää
        vuosikokous. Kannatusjäsenmaksu on voimassa 1. kesäkuuta ja 31. toukokuuta välisen ajan.
        Kunniajäsenet eivät suorita jäsenmaksuja.
        
        5. Kurinpitotoimet
        Yhdistyksen jäsenelle voidaan kohdistaa kurinpitotoimia, mikäli tämä on menettelyllään
        yhdistyksessä tai sen ulkopuolella huomattavasti ja tahallisesti vahingoittanut yhdistystä.
        Päätösvalta kurinpitotoimien käyttämisessä on yhdistyksen hallituksella. Kurinpitotoimina
        voidaan käyttää varoituksia, jäsenpalvelujen epäämistä määräajaksi sekä porttikieltoa
        yhdistyksen tilaan ja tapahtumiin enintään 12 kuukauden ajaksi kerrallaan.
        Ennen kurinpitotoimien toimeenpanemista asianomaiselle on annettava mahdollisuus
        selityksen antamiselle hallitukselle asiaan liittyen.

        6. Hallitus
        Yhdistyksen asioita hoitaa hallitus, johon kuuluu vuosikokouksessa valitut puheenjohtaja ja 2-
        8 muuta varsinaista jäsentä. Hallituksen toimikausi on kalenterivuosi. Hallitus valitsee
        keskuudestaan varapuheenjohtajan, sihteerin ja rahastonhoitajan, sekä määrittää hallituksen
        muiden jäsenten tehtävät. Hallitus kokoontuu puheenjohtajan tai hänen estyneenä ollessaan
        varapuheenjohtajan kutsusta, kun he katsovat siihen olevan aihetta tai kun vähintään puolet
        hallituksen jäsenistä sitä vaatii. Hallitus on päätösvaltainen, kun vähintään puolet sen
        jäsenistä, puheenjohtaja tai varapuheenjohtaja mukaanluettuna on läsnä. Äänestykset
        ratkaistaan ehdottomalla ääntenenemmistöllä. Äänten mennessä tasan ratkaisee
        puheenjohtajan ääni.
        Perustellusta syystä yhdistyksen kokous voi vapauttaa hallituksen jäsenen tehtävästään
        kesken toimikauden, jolloin kokouskutsussa on mainittava asiasta. Tehtävästä vapautetun
        henkilön tilalle voidaan tarvittaessa valita uusi henkilö jäljellä olevaksi toimikaudeksi.
        6.1. Toimihenkilöt
        Yhdistyksen hallitus voi erityisiä tehtäviä varten asettaa määräaikaisia toimihenkilöitä,
        kuitenkin enintään hallituksen toimikauden ajaksi. Näihin toimiin voidaan tarvittaessa nimetä
        myös yhdistyksen ulkopuolinen henkilö. Yhdistyksen hallitus voi antaa toimihenkilöiden
        toimintaan liittyviä sääntöjä ja määräyksiä.
        Perustellusta syystä yhdistyksen hallitus voi vapauttaa toimihenkilön tehtävästään kesken
        toimikauden, jolloin kokouskutsussa on mainittava asiasta. Tehtävästä vapautetun henkilön
        tilalle voidaan tarvittaessa valita uusi henkilö jäljellä olevaksi toimikaudeksi.

        7. Yhdistyksen nimen kirjoittaminen
        Yhdistyksen nimen kirjoittaa puheenjohtaja tai varapuheenjohtaja yhdessä hallituksen jäsenen
        kanssa.

        8. Tilikausi ja toiminnantarkastus
        Yhdistyksen toimi- ja tilikausi on kalenterivuosi. Yhdistyksen hallintoa ja taloutta valvoo yksi
        (1) toiminnantarkastaja, lisäksi yhdistykselle valitaan yksi (1) varatoiminnantarkastaja.
        Toiminnantarkastajien toimikausi on kalenterivuosi. Yhdistyksen hallintoon ja kirjanpitoon
        liittyvät asiakirjat on toimitettava toiminnantarkastajille tarkastettaviksi viimeistään neljä (4)
        viikkoa ennen vuosikokousta tai toiminnantarkastajien sitä pyytäessä. Toiminnantarkastajien
        tulee toimittaa asiakirjat ja toiminnantarkastuskertomus yhdistyksen hallitukselle viimeistään
        kahta (2) viikkoa ennen vuosikokousta.

        9. Yhdistyksen kokoukset
        Yhdistyksen kokoukseen voidaan osallistua hallituksen tai yhdistyksen kokouksen niin
        päättäessä myös tietoliikenneyhteyden tai muun teknisen apuvälineen avulla kokouksen
        aikana.

        Yhdistyksen vuosikokous pidetään vuosittain hallituksen määräämänä päivänä loka-
        joulukuussa.

        Yhdistyksen kokouksissa on jokaisella jäsenellä yksi ääni. Yhdistyksen kokouksen
        päätökseksi tulee, ellei säännöissä ole toisin määrätty, se mielipide, jota on kannattanut yli
        puolet annetuista äänistä. Äänten mennessä tasan ratkaisee kokouksen puheenjohtajan ääni,
        vaaleissa kuitenkin arpa.

        10. Yhdistyksen kokousten koollekutsuminen
        Hallituksen on kutsuttava yhdistyksen kokoukset koolle sähköpostitse vähintään seitsemän
        vuorokautta ennen kyseisen kokouksen ajankohtaa.

        11. Vuosikokous
        Yhdistyksen vuosikokouksessa käsitellään seuraavat asiat:
        1. kokouksen avaus
        2. valitaan kokouksen puheenjohtaja, sihteeri, kaksi (2) pöytäkirjantarkastajaa ja tarvittaessa
        kaksi (2) ääntenlaskijaa
        3. todetaan kokouksen laillisuus ja päätösvaltaisuus
        4. hyväksytään kokouksen työjärjestys
        5. esitetään tilinpäätös, vuosikertomus ja toiminnantarkastajien lausunto
        6. päätetään edeltävän toimikauden tilinpäätöksen vahvistamisesta, ja päätetään sen
        hallituksen sekä muiden vastuuvelvollisten vastuuvapauden myöntämisestä
        7. vahvistetaan toimintasuunnitelma, tulo- ja menoarvio sekä jäsenmaksun ja
        kannatusjäsenmaksun suuruus
        8. valitaan hallituksen puheenjohtaja ja muut jäsenet
        9. valitaan yksi (1) toiminnantarkastaja ja yksi (1) varatoiminnantarkastaja
        10. käsitellään muut kokouskutsussa mainitut asiat
        11. kokouksen päättäminen
        Mikäli yhdistyksen jäsen haluaa saada jonkin asian yhdistyksen vuosikokouksen
        käsiteltäväksi, on hänen ilmoitettava siitä kirjallisesti hallitukselle niin hyvissä ajoin, että asia
        voidaan sisällyttää kokouskutsuun.

        12. Sääntöjen muuttaminen
        Päätös sääntöjen muuttamisesta on tehtävä yhdistyksen kokouksessa vähintään kolmen
        neljäsosan (3/4) enemmistöllä annetuista äänistä. Kokouskutsussa on mainittava sääntöjen
        muuttamisesta.

        13. Yhdistyksen purkaminen ja lakkauttaminen
        Yhdistys purkautuu, jos yhdistys tekee siitä päätöksen viiden kuudesosan (5/6)
        ääntenenemmistöllä kahdessa (2) peräkkäisessä kokouksessa, joiden väli on vähintään yksi
        (1) kuukausi. Purkamisesitys on mainittava kokouskutsussa.
        Yhdistyksen purkautuessa käytetään yhdistyksen varat yhdistyksen tarkoituksen
        edistämiseen purkamisesta päättävän kokouksen määräämällä tavalla. Yhdistyksen tullessa
        lakkautetuksi käytetään sen varat samaan tarkoitukseen.`}}>
      </Container> */}
    </Container>

  )
}

export default Rules